import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Account, AuthState } from "./types";
import { jwtDecode } from 'jwt-decode';
import { JWToken } from '../api/types';

const initialState: AuthState = {
  account: null,
  accessToken: null,
  accessTokenExpires: null,
  refreshToken: null
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    logOut: () => {
      return { ...initialState };
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;

      const decoded = jwtDecode<JWToken>(action.payload);

      state.accessTokenExpires = decoded.exp || null;
      state.account = decoded.account;

    },
    setAccessTokenExpiry: (state, action: PayloadAction<number>) => {
      state.accessTokenExpires = action.payload;
    },
    setAccount: (state, action: PayloadAction<Account>) => {
      state.account = action.payload;
    },
    setRefreshToken: (state, action: PayloadAction<string>) => {
      state.refreshToken = action.payload;
    }
  }
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
